import styled from "styled-components";
import { GridBox } from "@pochta/ui";
export var FooterIconWrapper = styled.div.withConfig({
  displayName: "Footerstyles__FooterIconWrapper",
  componentId: "sc-ks6h4k-0"
})(["color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.palette.neutralsBlack.hex50;
});
export var FooterAppStore = styled.a.withConfig({
  displayName: "Footerstyles__FooterAppStore",
  componentId: "sc-ks6h4k-1"
})(["display:inline-block;background-image:url(https://static.pochta.ru/footer/images/appStore.svg);width:135px;height:40px;"]);
export var FooterGooglePlay = styled.a.withConfig({
  displayName: "Footerstyles__FooterGooglePlay",
  componentId: "sc-ks6h4k-2"
})(["display:inline-block;background-image:url(https://static.pochta.ru/footer/images/googlePlay.svg);width:135px;height:40px;margin-left:17px;", "{margin-left:0;}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.mobile;
});
export var FooterMain = styled.footer.withConfig({
  displayName: "Footerstyles__FooterMain",
  componentId: "sc-ks6h4k-3"
})(["box-sizing:border-box;*,::after,::before,*::after,*::before{box-sizing:inherit;}background-color:", ";color:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.neutralsBlack.hex5;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette.neutralsBlack.hex80;
});
export var FooterCompactPart = styled.div.withConfig({
  displayName: "Footerstyles__FooterCompactPart",
  componentId: "sc-ks6h4k-4"
})(["padding-top:24px;", "{padding-top:19px;}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.mobile;
});
export var FooterFullPart = styled.div.withConfig({
  displayName: "Footerstyles__FooterFullPart",
  componentId: "sc-ks6h4k-5"
})(["padding:18px 0;border-bottom:1px solid ", ";", "{padding:42px 0 48px 0;}"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.palette.neutralsBlack.hex15;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakpoints.mobile;
});
export var FooterBottom = styled(GridBox).withConfig({
  displayName: "Footerstyles__FooterBottom",
  componentId: "sc-ks6h4k-6"
})(["color:", ";padding-bottom:23px;padding-top:26px;", "{padding-top:2px;}"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.palette.neutralsBlack.hex50;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.breakpointsHelpers.up("lg");
});
export var FooterCustomers = styled(GridBox).withConfig({
  displayName: "Footerstyles__FooterCustomers",
  componentId: "sc-ks6h4k-7"
})(["padding-right:12px;", "{padding-bottom:48px;padding-right:0;}"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.breakpoints.mobile;
});
export var FooterBusiness = styled(GridBox).withConfig({
  displayName: "Footerstyles__FooterBusiness",
  componentId: "sc-ks6h4k-8"
})(["border-left:1px solid ", ";padding-left:12px;", "{padding-top:48px;padding-left:0;border-left:0;border-top:1px solid ", ";}"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.palette.neutralsBlack.hex15;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.breakpoints.mobile;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.palette.neutralsBlack.hex15;
});
export var FooterTitle = styled.div.withConfig({
  displayName: "Footerstyles__FooterTitle",
  componentId: "sc-ks6h4k-9"
})(["font-weight:bold;color:", ";padding-bottom:12px;", "{padding-bottom:8px;}"], function (_ref14) {
  var theme = _ref14.theme;
  return theme.palette.neutralsBlack.hex50;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.breakpoints.mobile;
});
export var FooterApps = styled(GridBox).withConfig({
  displayName: "Footerstyles__FooterApps",
  componentId: "sc-ks6h4k-10"
})(["", "{padding-top:16px;margin-top:16px;border-top:1px solid ", ";}"], function (_ref16) {
  var theme = _ref16.theme;
  return theme.breakpoints.mobile;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.palette.neutralsBlack.hex15;
});